"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.colorInfo = exports.colorWarning = exports.colorError = exports.colorSuccess = void 0;
exports.colorSuccess = '#119647', exports.colorError = '#ea1000', exports.colorWarning = '#FF8000', exports.colorInfo = '#0288d1';
//# sourceMappingURL=color.js.map